/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Overrides_DescriptionInputs */

const fr_style_overrides_description = /** @type {(inputs: Style_Overrides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour aller plus loin que les options visuelles ci-dessus, vous pouvez injecter du CSS personnalisé dans le widget.`)
};

const en_style_overrides_description = /** @type {(inputs: Style_Overrides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To go beyond the visual options above, you can inject custom CSS into the widget.`)
};

/**
* | output |
* | --- |
* | "To go beyond the visual options above, you can inject custom CSS into the widget." |
*
* @param {Style_Overrides_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_description = /** @type {((inputs?: Style_Overrides_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_description(inputs)
	return en_style_overrides_description(inputs)
});